export type WebSession = {
  username: string;
  userId: string;
  sessionToken: string;
  signedInAt: string;
};

const sessionKey = "key.store.web.session";

export function loadWebSession(): WebSession | null {
  try {
    const raw = localStorage.getItem(sessionKey);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as WebSession;
  } catch {
    return null;
  }
}

export function saveWebSession(session: WebSession) {
  try {
    localStorage.setItem(sessionKey, JSON.stringify(session));
  } catch {
    return;
  }
}

export function clearWebSession() {
  try {
    localStorage.removeItem(sessionKey);
  } catch {
    return;
  }
}

